import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent } from '@web/shared/ui';
import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import {
  PublicCartAddButtonComponent,
  PublicSales,
} from '@web/shared/module/shop';

@Component({
  selector: 'app-public-boxes-carousel-tile',
  imports: [
    ImageThumbnailComponent,
    NgOptimizedImage,
    PublicCartAddButtonComponent,
    RouterLinkComponent,
  ],
  templateUrl: './public-boxes-carousel-tile.component.html',
  styleUrl: './public-boxes-carousel-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxesCarouselTileComponent {
  public readonly imageSrc = input.required<string>();
  public readonly imageAlt = input.required<string>();
  public readonly name = input.required<string>();
  public readonly slug = input.required<string>();
  public readonly sales = input.required<PublicSales>();

  /* prettier-ignore */
  protected readonly params = this.paramsSignal();
  protected readonly Route = Route;

  private paramsSignal(): Signal<RouterLinkParams> {
    return computed(() => {
      return {
        [RouteParam.Slug]: this.slug(),
      };
    });
  }
}
